"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import { useAuth } from "@/lib/auth-shim/client";

export function PostHogIdentify() {
    const { isLoaded, userId } = useAuth();

    useEffect(() => {
        if (!posthog.__loaded || !isLoaded) return;
        if (userId) {
            if (posthog.get_distinct_id() !== userId) posthog.identify(userId);
        } else if (posthog._isIdentified()) {
            posthog.reset();
        }
    }, [isLoaded, userId]);

    return null;
}
